import React, { useContext, useEffect, useState } from "react";
import { withTranslation } from "react-i18next";
import { BsFillCircleFill } from "react-icons/bs";
import { FcFinePrint } from "react-icons/fc";
import { useNavigate } from "react-router-dom";
import { LoaderContext } from "../../../App";
import RecentReportCard from "../../../components/Report/RecentReportCard";
import { LS_REGULATION_SELECTED_KEY } from "../../../core/constants/common";
import HomePageService from "../../../core/service/HomePageService";
import "./HomePage.scss";
import useHasPermission from "../../../core/hooks/useHasPermission";

function ReportBlock({ t, selectedYear, periodParams }) {
	// All hooks must be called first, in the same order every render
	const { setLoaderDisplay } = useContext(LoaderContext);
	const [reportCount, setReportCount] = useState({});
	const [reportESRSCount, setReportESRSCount] = useState({});
	const navigate = useNavigate();
	const [reportsMixed, setReportsMixed] = useState([]);
	const { hasGRIViewPermission, hasBRSRViewPermission, hasCSRViewPermission, hasVSMEViewPermission, hasGHGReportViewPermission } = useHasPermission();
	
	// Initialize glbRegulationId from localStorage synchronously
	const [glbRegulationId] = useState(() => {
		return localStorage.getItem(LS_REGULATION_SELECTED_KEY);
	});

	useEffect(() => {
		if (!glbRegulationId || !selectedYear) return;
		getReportDetails();
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [selectedYear, glbRegulationId, periodParams]);

	const getReportDetails = () => {
		setLoaderDisplay(true);
		const { periodStart, periodEnd, frequencyType } = periodParams || {};
		// const report1 = HomePageService.getReportDataCount(`${selectedYear}-01-01`, glbRegulationId);
		const report2 = HomePageService.getESRSReportDataCount(
			`${selectedYear}-01-01`,
			periodStart,
			periodEnd,
			glbRegulationId,
			frequencyType
		);
		Promise.all([ report2]).then(res => {
			setLoaderDisplay(false);
			// res[0].data.reportStatusCount.sort((a, b) => a.daysSinceLastModified - b.daysSinceLastModified);
			// res[0].data.reportStatusCount.forEach(element => {
			// 	element['type'] = element.name.substring(0, 3);
			// });
			// const trimmed1 = res[0].data.reportStatusCount.slice(0, 4);
			// setReportCount(res[0].data.statusCounts);
			res[0].data.reportStatusCount.sort((a, b) => a.daysSinceLastModified - b.daysSinceLastModified);
			const trimmed2 = res[0].data.reportStatusCount.slice(0, 6);
			setReportESRSCount(res[0].data.statusCounts);
			setReportsMixed(trimmed2);
		}).catch(err => {
			setLoaderDisplay(false);
		});
	}

	const renderRecentReports = () => {
		return (
			<>
				{reportsMixed?.length === 0 && renderEmptyDataLabel()}
				{
					reportsMixed?.length > 0 &&
					reportsMixed?.map((report, index) => {
						return (
							<div className="col-md-4 p-1" key={`recentReport-${index}`}>
								<RecentReportCard report={report} />
							</div>
						);
					})
				}
			</>
		)
	}

	const renderEmptyDataLabel = () => {
		return (
			<div className="Nodatafound_box">
				<h6><FcFinePrint className="me-2" />{t("Nodatafound.label")}</h6>
			</div>
		)
	};

	const gotoReportPage = (page) => {
		navigate("../reporting_list?page=" + page);
	}

	return (
		<>
			<div className="HomeCard mb-3">
				<div className="HomeCardhead">
					<div className="HomeCardhead_in">
						<h5>{t("ReportBlock.key19")}</h5>
					</div>
					<div className="Reportablock_event">
						<ul>
							<li onClick={() => gotoReportPage(1)} className="cursor">
								<BsFillCircleFill className="text-Medium" />
								{(reportCount?.FINALIZED ?? 0) + (reportESRSCount?.FINALIZED ?? 0)} {t("Finalized.label")}
							</li>
							<li onClick={() => gotoReportPage(0)} className="cursor">
								<BsFillCircleFill className="text-High" />
								{(reportCount?.DRAFT ?? 0) + (reportESRSCount?.DRAFT ?? 0)} {t("Draft.label")}
							</li>
							<li onClick={() => gotoReportPage(2)} className="cursor">
								<BsFillCircleFill className="text-danger" />
								{(reportCount?.NOT_STARTED ?? 0) + (reportESRSCount?.NOT_STARTED ?? 0)} {t("NotStarted.label")}
							</li>
						</ul>
					</div>
				</div>
				<div className="HomeCardBody pb-2">
					<h6 className="">{t("ReportBlock.key20")}</h6>
					<div className="row m-0">
						{renderRecentReports()}
					</div>
				</div>
				<div className="HomeCardFooter" hidden={!(hasGRIViewPermission()||hasBRSRViewPermission()||hasCSRViewPermission()||hasVSMEViewPermission()||hasGHGReportViewPermission())}>
					{t("ForMoreDetails.label")} <a href="#" onClick={(e) => { e.preventDefault(); gotoReportPage(1); }}>{t("ReportBlock.key21")}</a>
				</div>
			</div>
		</>
	);
};

export default withTranslation()(ReportBlock);